import {EN} from "../ui/constants";


export const getInvoice = (id) => {
    window.open(`${EN.BASE_URL}/invoice?slot_id=${id}`
    );
};
